/* A wrapper around SockJS so that we make sure that we only
 * send messages of types that our backend supports.
 *
 * Contains both the types of messages sent and received as well as
 * helper functions to construct these.
 */

import { AuthState } from '@shared/auth';
import * as SockJS from 'sockjs-client';
import {
  AuthSubMessage,
  ChannelSubMessage,
  OnlineOfflineSubUnsubMessage,
  SockMessageSend,
} from './message-send-event.model';

interface SockBaseRawEvent {
  type: string;
}

type SockOpenRawEvent = SockBaseRawEvent;

interface SockCloseRawEvent extends SockBaseRawEvent {
  code: number;
  reason: string;
  wasClean: boolean;
}

interface SockMessageRawEvent extends SockBaseRawEvent {
  data: string;
}

enum State {
  CONNECTING = 0,
  OPEN,
  CLOSING,
  CLOSED,
}

export function generateOnlineOfflineSub(
  userIds: number[],
): OnlineOfflineSubUnsubMessage {
  return {
    channel: 'onlineoffline',
    body: {
      route: 'getsub',
      users: userIds,
    },
  };
}

export function generateOnlineOfflineUnsub(
  userIds: number[],
): OnlineOfflineSubUnsubMessage {
  return {
    channel: 'onlineoffline',
    body: {
      route: 'unsub',
      users: userIds,
    },
  };
}

export function generateChannelSubMessage(
  channels: number[],
): ChannelSubMessage {
  return {
    channel: 'channels',
    body: { channels },
  };
}

export function generateHeader(auth: AuthState): AuthSubMessage {
  return {
    channel: 'auth',
    body: {
      hash2: auth.token,
      user_id: parseInt(auth.userId, 10),
    },
  };
}
export class Socket {
  private sock: any; // SockJS doesn't export its type.
  public onopen: (e: SockOpenRawEvent) => any;
  public onclose: (e: SockCloseRawEvent) => any;
  public onmessage: (e: SockMessageRawEvent) => any;

  constructor(url: string) {
    this.sock = new SockJS(url);
    this.sock.onopen = (e: SockOpenRawEvent) => this.onopen(e);
    this.sock.onclose = (e: SockCloseRawEvent) => this.onclose(e);
    this.sock.onmessage = (e: SockMessageRawEvent) => this.onmessage(e);
  }

  public readyState(): State {
    return this.sock.readyState;
  }

  public send(message: SockMessageSend): void {
    this.sock.send(JSON.stringify(message));
  }

  public close(code?: number, reason?: string): void {
    this.sock.close(code, reason);
  }
}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/core/websocket/sock-js.ts